  document.addEventListener('alpine:init', () => {
    Alpine.data('productRecs', () => {
      return (
        {
        init() {
          this.addEventListeners();
          this.getRecommendedData();
        },
        addEventListeners() {
        },
        setRecsHTML(recsData) {
          const html = document.createElement('div');
          html.innerHTML = recsData;
          const recommendations = html.querySelector('[js-product-recs="recsContain"]');
  
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.$el.querySelector('[js-product-recs="recsContain"]').innerHTML = recommendations.innerHTML;
          }
        },
        getRecommendedData() {
          const slider = this.$el.querySelector('[js-product-recs="recsContain"]');
          const url = slider.dataset.url;
          console.log('url', url);

          fetch(url)
            .then((response) => response.text())
            .then((recsData) => {
              console.log("🚀 ~ recsData:", recsData)
              this.setRecsHTML(recsData);
            })
            .catch((e) => {
              console.error(e);
            });
        },
      }
      );
    });

        Alpine.data('collections', () => ({
      openFilterDrawer: false,
      loading: false,
      sectionContent: '',
      queryParam: '',
      cache: [],
      currentSearchParams: window.location.search.slice(1),

      init() {
        // Handle back and forward navigation
        window.addEventListener('popstate', (event) => {
          const newParams = event.state ? event.state.searchParams : this.currentSearchParams;
          if (newParams !== this.currentSearchParams) {
            this.updateContent(newParams, false);
          }
        });
      },

      async handleFormSubmit(event) {
        let form = event.target.closest('form');
        const formData = new URLSearchParams(new FormData(form));
        await this.updateContent(formData.toString());
      },

      async handleResetFilters(event) {
        let form = event.target.closest('form');
        form.reset();
        await this.updateContent('');
      },

      // Remove a single active filter from a pill's X. `url` is Shopify's
      // value.url_to_remove (path + remaining filter params); we pass its query
      // through the same AJAX flow as the filter form.
      async removeFilter(url) {
        const params = url.indexOf('?') > -1 ? url.split('?')[1] : '';
        await this.updateContent(params);
      },

      async updateContent(params, pushState = true) {
        // Force in-stock only on all collection browsing (filter, sort, reset, back/forward).
        // set() only touches this key, leaving repeated filter.v.option.* (OR) values intact.
        const _sp = new URLSearchParams(params);
        _sp.set('filter.v.availability', '1');
        params = _sp.toString();

        console.log('🚀 ~ updateContent ~ params:', params);
        const container = document.querySelector('#CollectionAjaxResult').parentElement;

        try {
          this.loading = true;
          console.log('🚀 ~ updateContent ~ this.getSections():', this.getSections());
          const url = `${window.location.pathname}?sections=${this.getSections()}&${params}`;

          // Check cache
          let cached = this.cache.find((item) => item.url === url);
          if (cached) {
            console.log('🚀 ~ updateContent ~ cached:', cached);
            Alpine.morph(container, cached.html);
            AOS.refreshHard();
          } else {
            let response = await fetch(url);
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            let data = await response.json();

            let htmlContent = Object.values(data).join('');
            console.log('🚀 ~ updateContent ~ htmlContent:', htmlContent);

            Alpine.morph(container, htmlContent);
            AOS.refreshHard();

            // Cache the response
            this.cache.push({ url, html: htmlContent });
          }

          // Keep filter checkboxes in sync with the active params. Alpine.morph
          // preserves the live `checked` state of inputs, so removing a filter via
          // a pill wouldn't otherwise uncheck it in the drawer until a page refresh.
          const activeParams = new URLSearchParams(params);
          document.querySelectorAll('#filtersForm input[type="checkbox"]').forEach((cb) => {
            cb.checked = activeParams.getAll(cb.name).includes(cb.value);
          });

          // Keep the tracked params in sync so the popstate handler compares against
          // the current state (fixes filter back/forward on the collection page).
          this.currentSearchParams = params;

          // Update browser history
          if (pushState) {
            history.pushState({ searchParams: params }, '', `${window.location.pathname}?${params}`);
          }
        } catch (error) {
          console.error('Fetch error:', error);
          window.location.href = `?${params}`;
        } finally {
          this.loading = false;
        }
      },

      getSections() {
        let sections = [];
        document.querySelectorAll('[data-collections-content]').forEach((element) => {
          const sectionId = element.closest('[id^="shopify-section-"]');
          if (sectionId) {
            sections.push(sectionId.id.replace('shopify-section-', ''));
          }
        });
        if (sections.length > 5) {
          throw new Error('Too many sections to update at once');
        }
        return sections.join(',');
      },
    }));
  });